import React from 'react';

import MutateCardTags from '../../MutateCard/MutateCardTags';

import MutateTaskDate from './MutateTaskDate';
import MutateTaskInput from './MutateTaskInput';

import './index.scss';

const MutateTask = ({ name, language }) => (
  <>
    <MutateTaskInput name={`${name}.title`} placeholder="Title" />
    <MutateTaskInput name={`${name}.description`} placeholder="Description" />
    <MutateTaskDate name={name} />
    <MutateCardTags
      style={{ marginBottom: '.875rem' }}
      name={`${name}.cards`}
      data-testid={`${name}.cards`}
      language={language}
    />
  </>
);

export default MutateTask;
